import { render, staticRenderFns } from "./Related-products.vue?vue&type=template&id=401a186e"
import script from "./Related-products.vue?vue&type=script&lang=js"
export * from "./Related-products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports